import React from 'react';

import { EmailCampaignSignupSingleBlockData } from 'api/cms';
import { AmpHeroBlock } from 'cms/blocks/Amp/AmpHeroBlock';
import { AmpBlockMappingComponentProps } from 'cms/blocks/BlockMapping';

export function AmpEmailCampaignSignupSingleBlock({
  content,
  blockId,
  data,
}: AmpBlockMappingComponentProps<EmailCampaignSignupSingleBlockData>) {
  return (
    <AmpHeroBlock
      content={content}
      blockId={blockId}
      data={{
        ...data,
        // @ts-expect-error fix me
        image: data.bgImage,
        text: data.headline,
        buttonText: data.buttonText,
        isEmailSignup: true,
      }}
    />
  );
}
